import './App.css';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import AppLayout from './layout/AppLayout';
import Benefits from './pages/Benefits';
import Solutions from './pages/Solutions';
import Home from './pages/Home2';
import Industries from './pages/Industries';
import Pricing from './pages/Pricing';

function App() {

  const router = createBrowserRouter([
    {
      path : "/",
      element : <AppLayout/>,
      children : [
        {
          index : true,
          element : <Home/>
        },
        {
          path : "/solution",
          element : <Solutions/>
        },
        {
          path : "/Benefits",
          element : <Benefits/>
        },
        {
          path : "/industries",
          element : <Industries/>
        },
        {
          path : "/pricing",
          element : <Pricing/>
        }
      ]
    },
  ]);

  return (
    <RouterProvider router={router} />
  );
}

export default App;
